import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason: string) => Promise<unknown> | void;
  isSubmitting?: boolean;
}

const MIN_LEN = 10;

export function CancelNfseDialog({
  open,
  onOpenChange,
  onConfirm,
  isSubmitting,
}: Props) {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();
  const disabled = trimmed.length < MIN_LEN || isSubmitting;

  const submit = async (): Promise<void> => {
    if (disabled) return;
    await onConfirm(trimmed);
    setReason('');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Cancelar NFS-e</DialogTitle>
          <DialogDescription>
            O cancelamento é enviado à prefeitura via Notaas. Informe o motivo; a
            justificativa fica registrada em auditoria.
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <label htmlFor="cancel-reason" className="mb-2 block text-sm font-medium">
            Justificativa
          </label>
          <textarea
            id="cancel-reason"
            rows={5}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Ex.: NF emitida com valor incorreto por engano…"
            className="w-full rounded-md border border-(--color-border) bg-(--color-surface) p-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--color-accent)"
          />
          <p className="mt-1 text-xs text-(--color-fg-muted)">
            Mínimo {MIN_LEN} caracteres. {trimmed.length}/{MIN_LEN}.
          </p>
        </DialogBody>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Voltar
          </Button>
          <Button onClick={submit} disabled={disabled}>
            {isSubmitting ? 'Cancelando…' : 'Cancelar NF'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
